import {Link} from 'react-router-dom'

import logo from '../../../assets/logo.svg'

import style from './HeaderLogo.module.css'

const HeaderLogo = () => (
  <Link className={style.container} to="/organizations">
    {}
    <img src={logo} />
  </Link>
)

export default HeaderLogo
